import {
	ID_EL_GORDO,
	ID_EURO_MILLIONS,
	ID_POWERBALL,
	ID_MEGASENA,
	ID_NATIONAL,
	ID_UK_LOTTO,
	ID_THUNDERBALL,
	ID_MEGA_MILLIONS,
	ID_LOTTO_AMERICA,
	ID_NATIONAL_THURSDAY,
	ID_QUINA,
	ID_LOTTO_FACIL,
	ID_EL_GORDO_NAVIDAD,
	ID_EURODREAMS_PT,
	ID_EURODREAMS_FR,
	ID_LOTO_FR,
	ID_KENO_FR,
} from './idsLotteries.js'

const eurodreamsContent = {
	name: 'EuroDreams',
	image: 'eurodreams.webp',
	link: 'https://www.national-lottery.com/eurodreams',
	link_rules:
		'https://www.loteriasyapuestas.es/en/centro-de-ayuda/como-se-juega/como-jugar-a-eurodreams#:~:text=Each%20EuroDreams%20bet%20consists%20of,bet%20are%202%2C50%20%E2%82%AC',
}

export const DETAIL_LOTTERIES_RULES = [
	{
		id: ID_EURO_MILLIONS,
		name: 'EuroMillions',
		slug: 'euromillions',
		image: 'euromillones.webp',
		link: 'https://www.national-lottery.com/euromillions',
		link_rules: 'https://www.national-lottery.co.uk/games/euromillions/about-euromillions',
	},
	{
		id: ID_EL_GORDO,
		name: 'El Gordo (La Primitiva)',
		slug: 'el_gordo',
		image: 'el_gordo_la_primitiva_red.webp',
		link: 'https://www.elgordodelaprimitiva.com.es',
		link_rules:
			'https://www.loteriasyapuestas.es/en/centro-de-ayuda/como-se-juega/como-jugar-a-el-gordo-de-la-primitiva',
	},
	{
		id: ID_POWERBALL,
		name: 'Powerball',
		slug: 'powerball',
		image: 'power_ball.webp',
		link: 'https://www.powerball.com',
		link_rules: 'https://www.powerball.com/#:~:text=How%20To%20Play',
	},
	{
		id: ID_MEGASENA,
		name: 'Megasena',
		slug: 'megasena',
		image: 'mega_sena.webp',
		link: 'https://www.loteriasonline.caixa.gov.br/silce-web/#/mega-sena',
		link_rules:
			'https://loterias.caixa.gov.br/Paginas/Mega-Sena.aspx#:~:text=Como%20jogar-,Como%20jogar,-A%20Mega%2DSena',
	},
	{
		id: ID_UK_LOTTO,
		name: 'UK Lotto',
		slug: 'uk_lotto',
		image: 'logo_uk_lotto.webp',
		link: 'https://www.national-lottery.com/lotto',
		link_rules: 'https://www.national-lottery.co.uk/games/lotto/about-lotto',
	},
	{
		id: ID_THUNDERBALL,
		name: 'Thunderball',
		slug: 'thunderball',
		image: 'thunderball_logo.webp',
		link: 'https://www.national-lottery.com/thunderball',
		link_rules: 'https://www.national-lottery.co.uk/games/thunderball/about-thunderball',
	},
	{
		id: ID_MEGA_MILLIONS,
		name: 'Megamillions',
		slug: 'mega_millions',
		image: 'mega_millions.webp',
		link: 'https://www.megamillions.com',
		link_rules: 'https://www.megamillions.com/How-to-Play.aspx',
	},
	{
		id: ID_LOTTO_AMERICA,
		name: 'Lotto America',
		slug: 'lotto_america',
		image: 'lotto_america.webp',
		link: 'https://www.lottoamerica.com',
		link_rules: 'https://lottoamerica.com/rules',
	},
	{
		id: ID_LOTTO_FACIL,
		name: 'Lotofácil',
		slug: 'lotto_facil',
		image: 'lotto_facil.webp',
		link: 'https://www.loteriasonline.caixa.gov.br/silce-web/#/lotofacil',
		link_rules:
			'https://loterias.caixa.gov.br/Paginas/Lotofacil.aspx#:~:text=Como%20jogar-,Como%20jogar,-Jogue%20na%20Lotof%C3%A1cil',
	},
	{
		id: ID_NATIONAL,
		name: 'Loteria Nacional',
		slug: 'loteria_nacional',
		image: 'lottery_national.webp',
		link: 'https://www.loteriasyapuestas.es/es/loteria-nacional',
		link_rules: 'https://www.loteriasyapuestas.es/en/centro-de-ayuda/como-se-juega/jugar-a-loteria-nacional',
	},
	{
		id: ID_NATIONAL_THURSDAY,
		name: 'Loteria Nacional (Jueves)',
		slug: 'loteria_nacional_thursday',
		image: 'loteria_nacional_thursday.webp',
		link: 'https://www.loteriasyapuestas.es/es/loteria-nacional',
		link_rules: 'https://www.loteriasyapuestas.es/en/centro-de-ayuda/como-se-juega/jugar-a-loteria-nacional',
	},
	{
		id: ID_QUINA,
		name: 'Quina',
		slug: 'quina',
		image: 'quina.webp',
		link: 'https://loterias.caixa.gov.br/Paginas/Quina.aspx',
		link_rules: 'https://loterias.caixa.gov.br/Paginas/Quina.aspx#:~:text=Como%20jogar',
	},
	{
		id: ID_EL_GORDO_NAVIDAD,
		name: 'El Gordo (navidad)',
		slug: 'el_gordo_navidad',
		image: 'loteria_nacional_de_navidad.webp',
		link: 'https://www.elgordo.com/en/shop/elgordo-lottery',
		link_rules: 'https://www.elgordo.net/en/how-to-play',
	},
	{
		id: ID_EURODREAMS_PT,
		slug: 'eurodreams_pt',
		...eurodreamsContent,
	},
	{
		id: ID_EURODREAMS_FR,
		slug: 'eurodreams_fr',
		...eurodreamsContent,
	},
	{
		id: ID_LOTO_FR,
		name: 'Loto (FDJ)',
		slug: 'loto_fr',
		image: 'loto.webp',
		link: 'https://www.fdj.fr/jeux-de-tirage/loto',
		link_rules: 'https://www.fdj.fr/jeux-de-tirage/loto/comment-jouer',
	},
	{
		id: ID_KENO_FR,
		name: 'Keno (FDJ)',
		slug: 'keno_fr',
		image: 'keno.webp',
		link: 'https://www.fdj.fr/jeux-de-tirage/keno',
		link_rules: 'https://www.fdj.fr/jeux-de-tirage/keno/comment-jouer',
	},
]
